// Ajax cart JS for Drawer and Cart Page
const drawerSelectors = {
    cartIcons: document.querySelectorAll('.header__icon--cart'),
    cartIconDesktop: document.querySelector('#cart-icon-desktop'),
    cartIconMobile: document.querySelector('#cart-icon-mobile'),
    cartCloseBtn: document.querySelector('.close-ajax--cart'),
    cartTotal: document.querySelector('#ajax-cart [data-cart-total]'),
    b2bCartTotal: document.querySelector('#ajax-cart [data-cart-b2b-total]'),
    b2bCartCheckoutBtn: document.querySelector('#ajax-cart [data-b2b-checkout]'),
    cartTotalDiscount: document.querySelector('#ajax-cart [data-cart-total-discount]'),
    cartItemCount: document.querySelector('#ajax-cart [data-cart-item-total]')
};

const ProgressBarType = window.globalVariables?.settings?.progress_bar_type || 'total_items';

class AjaxCart extends HTMLElement {
    constructor() {
        super();

        this.openeBy = drawerSelectors.cartIcons;
        this.isOpen = this.classList.contains('opened-drawer');
        this.cartForm = this.querySelector('form[data-cart-form]');
        this.closeBtn = this.querySelector('.close-ajax--cart');
        this.sectionID = 'component-cart-drawer';

        if (window.globalVariables.template == 'cart') {
            this.style.visibility = 'visible';
            this.sectionID = document.getElementById('cart--items').dataset.id;
            this.updateEvents();
        } else {
            this.addAccessibilityAttributes(this.openeBy);
            this.getCartData();
        }

        let storedCountdownTime = localStorage.getItem('countdownTime');
        this.startCountdown(storedCountdownTime ? parseInt(storedCountdownTime) : 5, 5);
        this.getOffers();

        if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
    }

    connectedCallback() {
        this.bindEvents();
        this.cartNoteInput();
    }

    /**
     * Observe attribute of component
     *
     * @returns {array} Attributes to Observe
     */
    static get observedAttributes() {
        return ['updating'];
    }

    /**
     * Add accessibility attributes to Open Drawer buttons
     *
     * @param {Node Array} openDrawerButtons Cart Icons
     */
    addAccessibilityAttributes(openDrawerButtons) {
        let _this = this;
        openDrawerButtons.forEach(element => {
            element.setAttribute('role', 'button');
            element.setAttribute('aria-expanded', false);
            element.setAttribute('aria-controls', _this.id);
        });
    }

    /**
     * Escape Click event to close drawer when focused within Cart Drawer
     *
     * @param {event} Event instance
     */
    onKeyUp(event) {
        if (event.code && event.code.toUpperCase() !== 'ESCAPE') return;
        (this.closeBtn || drawerSelectors.cartCloseBtn)?.dispatchEvent(new Event('click'));
    }

    /**
     * bind dclick and keyup event to Cart Icons
     * bind keyUp event to Cart drawer component
     * bind Other inside element events
     *
     */
    bindEvents() {
        if (window.globalVariables.template !== 'cart') {
            this.openeBy.forEach(cartBtn => cartBtn.addEventListener('click', this.openCartDrawer.bind(this)));
            this.addEventListener('keyup', this.onKeyUp.bind(this));

            this.closeBtn = this.closeBtn || this.querySelector('.close-ajax--cart');
            if (this.closeBtn) {
                this.closeBtn.addEventListener('click', this.closeCartDrawer.bind(this));
            } else if (drawerSelectors.cartCloseBtn) {
                drawerSelectors.cartCloseBtn.addEventListener('click', this.closeCartDrawer.bind(this));
            }
        }

        const checkoutBtn = this.querySelector('#checkout');
        if (checkoutBtn) {
            checkoutBtn.addEventListener('click', () => {
                checkoutBtn.innerHTML = 'CHECKING OUT...';
                setTimeout(() => {
                    checkoutBtn.innerHTML = 'CHECKOUT NOW';
                }, 8000)
            });
        }
    }

    /**
     * bind Other inside element events to DOM
     *
     */
    updateEvents() {
        this.cartForm.querySelectorAll('[data-item-remove]').forEach(button => button.addEventListener('click', this.removeItem.bind(this)));
        this.cartForm.querySelectorAll('[data-qty-btn]').forEach(button => button.addEventListener('click', this.manageQtyBtn.bind(this)));
        this.cartForm.querySelectorAll('[data-qty-input]').forEach(button => button.addEventListener('keyup', (e) => {
            if (e.key == 'Enter' || e.keyCode == 13) this.onQtyChange(e);
        }));
    }

    /**
     * Open Cart drawer and add focus to drawer container
     *
     * @param {event} Event instance
     */
    openCartDrawer(event) {
        if (document.querySelector('.keep_old_rebuy_cart')) {
            return;
        }
        if (!window.globalVariables.cart_drawer) {
            window.location.href = window.routes.cart_fetch_url || '/cart';
            return;
        }

        if (document.querySelector('#mobile-menu-drawer').classList.contains('opened-drawer')) {
            document.querySelector('.close-mobile--navbar').dispatchEvent(new Event('click'));
        }

        this.classList.add('opened-drawer');
        siteOverlay.prototype.showOverlay();
        Utility.forceFocus(this.querySelector('.cart-title'));
        Utility.trapFocus(this, this.closeBtn || drawerSelectors.cartCloseBtn);

        // Fix for Rebuy widget unresponsiveness (inert attribute issue)
        const rebuyWidgets = this.querySelectorAll('.rebuy-widget');
        const clearInert = (element) => {
            if (element.hasAttribute('inert')) {
                element.removeAttribute('inert');
                element.removeAttribute('aria-hidden'); // often paired with inert
            }
        };

        rebuyWidgets.forEach(widget => {
            clearInert(widget);
            // Also recursively check children just in case
            widget.querySelectorAll('[inert]').forEach(clearInert);
        });

        // Persistent check (in case Rebuy script runs after drawer open)
        if (this.rebuyObserver) this.rebuyObserver.disconnect();
        this.rebuyObserver = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                if (mutation.type === 'attributes' && (mutation.attributeName === 'inert' || mutation.attributeName === 'aria-hidden')) {
                    const target = mutation.target;
                    if (target.hasAttribute('inert')) {
                        // Only remove if it is or is inside a rebuy widget
                        if (target.classList.contains('rebuy-widget') || target.closest('.rebuy-widget')) {
                            target.removeAttribute('inert');
                            target.removeAttribute('aria-hidden');
                        }
                    }
                }
            });
        });

        rebuyWidgets.forEach(widget => {
            this.rebuyObserver.observe(widget, { attributes: true, attributeFilter: ['inert', 'aria-hidden'], subtree: true });
        });

        if (event) {
            event.preventDefault();
            let openBy = event.currentTarget;
            openBy.setAttribute('aria-expanded', true);
        }
    }

    /**
     * Close Cart drawer and Remove focus from drawer container
     *
     * @param {event} Event instance
     */
    closeCartDrawer(event, elementToFocus = false) {
        if (event == undefined) return;

        event.preventDefault();
        this.classList.remove('opened-drawer');
        siteOverlay.prototype.hideOverlay();

        if (this.rebuyObserver) {
            this.rebuyObserver.disconnect();
            this.rebuyObserver = null;
        }

        let openByEle = event.currentTarget;
        if (openByEle && typeof openByEle.setAttribute === 'function') {
            openByEle.setAttribute('aria-expanded', false);
        }
        Utility.removeTrapFocus(elementToFocus);

        let actionBtn = drawerSelectors.cartIconDesktop;
        if (window.innerWidth < 1024) {
            actionBtn = drawerSelectors.cartIconMobile;
        }
        Utility.forceFocus(actionBtn);

    }

    /**
     * Update cart HTML and Trigger Open Drawer event
     *
     * @param {string} cartHTML String formatted response from fetch cart.js call
     * @param {string} action Open Drawer as value if need to Open Cart drawer
     */
    _updateCart(response, action) {
        if (response === null) return;

        this.setAttribute('updating', true);

        // Convert the HTML string into a document object
        let cartHTML = response[this.sectionID];
        let parser = new DOMParser();
        cartHTML = parser.parseFromString(cartHTML, 'text/html');

        let cartJSONEle = cartHTML.querySelector('[data-cartScriptJSON]');
        window.globalVariables.cart = JSON.parse(cartJSONEle.textContent);

        let cartElement = cartHTML.querySelector('form');
        this.cartForm.innerHTML = cartElement.innerHTML;

        let cartTotal = Shopify.formatMoney(window.globalVariables.cart.total_price, window.globalVariables.money_format);
        if (drawerSelectors.cartTotal){
            drawerSelectors.cartTotal.innerHTML = cartTotal;
        }
        if (drawerSelectors.b2bCartTotal) {
            drawerSelectors.b2bCartTotal.innerHTML = cartTotal;
        }
        if (drawerSelectors.b2bCartCheckoutBtn) {
            if (window.globalVariables.cart.total_price >= 30000) {
                drawerSelectors.b2bCartCheckoutBtn.removeAttribute('disabled');
                drawerSelectors.b2bCartCheckoutBtn.classList.remove('disabled')
            } else {
                drawerSelectors.b2bCartCheckoutBtn.setAttribute('disabled', 'disabled');
                drawerSelectors.b2bCartCheckoutBtn.classList.add('disabled')
            }
        }

        let countExcludedTags = window.globalVariables.settings.cart_item_exclude_tag;
        let excludeQuantity = 0;
        if (countExcludedTags) {
            countExcludedTags = countExcludedTags.split(',');
            document.querySelectorAll('.cart-drawer [data-cart-item]').forEach(ele => {
                let productTags = ele.querySelector('[data-pd-tags]')?.getAttribute('data-pd-tags');
                if (productTags) {
                    productTags = JSON.parse(productTags);
                    let isExcludedProduct = productTags.some(value => countExcludedTags.includes(value));
                    if (isExcludedProduct) {
                        excludeQuantity += parseInt(ele.querySelector('[data-qty-input]')?.getAttribute('value') || 0);
                    }
                }
            })
        }
        let itemsCount = window.globalVariables.cart.item_count - excludeQuantity > 0 ? window.globalVariables.cart.item_count - excludeQuantity : 0;
        drawerSelectors.cartItemCount.innerHTML = itemsCount;

        let cart_items_count = cartHTML.querySelector('[data-item-count]');
        if (cart_items_count) this.querySelector('[data-item-count]').innerHTML = cart_items_count.innerHTML;

        let cartCountElements = document.querySelectorAll('#cart-icon-desktop .cart-count_bf');
        cartCountElements.forEach((cartCountElement) => {
            if (cartCountElement) cartCountElement.innerHTML = itemsCount;
        });

        let elements = this.querySelectorAll('[data-checkoutBtns], [data-cartnote]');
        let cart_container = this.querySelector('.cart-form-container');
        if (window.globalVariables.cart.item_count <= 0 || window.globalVariables.cart.total_price <= 0) {
            elements.forEach((div) => {
                div.classList.add('d-none');
            });
            cart_container.classList.add('empty_cart');
        } else {
            elements.forEach((div) => {
                div.classList.remove('d-none');
            });
            cart_container.classList.remove('empty_cart');
        }

        this.updateEvents();

        if (window.globalVariables.template !== 'cart' && window.globalVariables.cart_drawer && action === 'open_drawer') {
            this.openCartDrawer();
        }

        this.calculateDiscount();
        this.handleFreeShippingBar();
        this.manageSpecialDiscount();
        this.updatePromotionGroupTaglines();
    }

    /**
     * Fetch latest cart data
     *
     * @param {string} action Open Drawer as value if need to Open Cart drawer or else let it be empty
     */
    getCartData(action) {
        let cartRoute = `${window.location.pathname}?sections=${this.sectionID},header`;
        return fetch(cartRoute).then(response => {
            return response.json();
        }).then(response => {
            this._updateCart(response, action);
            return response;
        })
    }

    /**
    * Update Quantity API call
    *
    * @param {string} line Line Index value of cart Item (Starts from 1)
    * @param {integer} quantity Quantity to update
    */
    updateItemQty(line, quantity) {
        let lineItem = document.querySelectorAll('[data-cart-item]')[line - 1];

        if (lineItem) { lineItem.classList.add('updating'); }
        const body = JSON.stringify({
            line,
            quantity,
            sections: `${this.sectionID}`
        });

        fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
            .then((response) => {
                return response.text();
            })
            .then((_state) => {
                let dataJSON = ((typeof _state == 'object') ? _state : JSON.parse(_state));
                if (dataJSON.errors) {
                    console.log(dataJSON.errors, '<--cart update error')
                    let cartItem = window.globalVariables.cart.items[line - 1];
                    let qtyInput = this.cartForm.querySelector(`input[data-qty-input][data-index="${line}"]`);
                    if (qtyInput) qtyInput.value = cartItem.quantity;
                    return;
                }
                window.globalVariables.cart = dataJSON;

                this._updateCart(dataJSON.sections);
            }).catch((error) => {
                console.log(error, '<--cart update error')
            }).finally(() => {
                if (lineItem) lineItem.classList.remove('updating')
                this.querySelectorAll('[data-qty-btn]').forEach(ele => ele.classList?.remove('qty_updating'));
                this.querySelector('.quantity-box .qty_processing')?.classList?.remove('qty_processing');
            });
    }

    /**
     * Remove Item Event
     *
     * @param {event} Event instance
     */
    removeItem(event) {
        event.preventDefault();
        let currentTarget = event.currentTarget;
        let itemIndex = currentTarget.dataset.index || null;
        if (itemIndex !== null) {
            this.updateItemQty(itemIndex, 0);
        }
    }

    /**
     * Cart Item Qunatity Increment/Decrement Button event
     *
     * @param {event} Event instance
     */
    manageQtyBtn(event) {
        event.preventDefault();
        let currentTarget = event.currentTarget;
        let action = currentTarget.dataset.for || 'increase';
        let $qtyInput = currentTarget.closest('[data-qty-container]').querySelector('[data-qty-input]');
        let qtyBtn = currentTarget.closest('[data-qty-btn]');
        let itemIndex = $qtyInput.dataset.index || 1;

        let stepQty = ($qtyInput.step) ? parseInt($qtyInput.step) : 1;
        let minQty = ($qtyInput.min) ? parseInt($qtyInput.min) : 1;
        let maxQty = ($qtyInput.max) ? parseInt($qtyInput.max) : null;

        let currentQty = parseInt($qtyInput.value) || minQty;
        let finalQty = currentQty;

        if (action === 'decrease' && currentQty <= 0) {
            return false;
        } else if (action === 'decrease') {
            finalQty = currentQty - stepQty;
            if (finalQty < 0) finalQty = 0;
        } else {
            finalQty = currentQty + stepQty;
        }
        qtyBtn.classList.add('qty_updating');
        qtyBtn.closest('.quantity-box').classList.add('qty_processing');

        this.updateItemQty(itemIndex, finalQty);
    }

    /**
     * Cart Item Qunatity Input change event
     *
     * @param {event} Event instance
     */
    onQtyChange(event) {
        const $qtyInput = event.currentTarget;
        const qtyValue = $qtyInput.value;
        const itemIndex = $qtyInput.dataset.index || null;
        if (itemIndex) this.updateItemQty(itemIndex, qtyValue);
    }

    /**
     * Manage Cart Notes
     */
    cartNoteInput() {
        const cartNoteEle = document.querySelector('[data-cartNote] [name="note"]');
        if (!cartNoteEle) return;

        const cartNoteSave = document.querySelector('[data-saveNote]');
        let cartNoteEvents = ['input', 'paste'];
        cartNoteEvents.forEach((eventName) => {
            cartNoteEle.addEventListener(eventName, (evt) => {
                const defaultNote = cartNoteEle.dataset.default;
                if (defaultNote !== cartNoteEle.value) {
                    cartNoteSave.style.display = 'block';
                } else {
                    cartNoteSave.style.display = 'none';
                }
            }, false);
        });

        //  Cart Note Change event
        cartNoteSave.addEventListener("click", evt => {
            evt.preventDefault();
            const cartNoteContainer = evt.currentTarget.closest('[data-cartNote]');
            const cartNote = cartNoteContainer.querySelector('[name="note"]').value.trim();
            if (cartNote.length <= 0) {
                alert('Add Note before proceeding');
                return;
            }

            const submitBtn = cartNoteContainer.querySelector('[data-saveNote]');
            const waitText = (submitBtn.dataset.adding_txt) ? submitBtn.dataset.adding_txt : 'Saving...';
            submitBtn.innerHTML = waitText;
            submitBtn.disabled = true;
            this.updateCartNote(cartNoteContainer);
        });
    }

    /**
     * Update Cart Note
     * @param {element} cartNoteContainer
     */
    updateCartNote(cartNoteContainer) {
        const _this = this;
        const cartNoteEle = cartNoteContainer.querySelector('[name="note"]');
        const cartNote = cartNoteEle.value.trim();
        const resultEle = cartNoteContainer.querySelector('[data-resultMsg]');
        const submitBtn = cartNoteContainer.querySelector('[data-saveNote]');
        const defaultText = (submitBtn.dataset.default) ? submitBtn.dataset.default : 'Save';

        let body = JSON.stringify({
            note: cartNote
        });
        fetch(`${routes.cart_update_url}`, {
            ...fetchConfig(), ...{ body }
        }).then(function (data) {
            if (data.status === 200) {
                if (resultEle) {
                    resultEle.innerText = 'Added note to Order!';
                    _this.manageResponseText(resultEle);
                }
                if (cartNoteEle) {
                    cartNoteEle.dataset.default = cartNote;
                }
                submitBtn.style.display = 'none';
                submitBtn.innerHTML = defaultText;
                submitBtn.disabled = false;
            }
            else {
                console.error('Request returned an error', data);
                if (resultEle) {
                    resultEle.innerText = data;
                    _this.manageResponseText(resultEle);
                }
                submitBtn.innerHTML = defaultText;
                submitBtn.disabled = false;
            }
        }).catch(function (error) {
            console.error('Request failed', error);
            if (resultEle) {
                resultEle.innerText = error;
                _this.manageResponseText(resultEle);
            }
            submitBtn.innerHTML = defaultText;
            submitBtn.disabled = false;
        });
    }

    /**
     * fade effect on reponse
     * @param {element} element
     */
    manageResponseText(element) {
        Utility.fadeEffect(element, 'fadeIn');
        setTimeout(() => {
            Utility.fadeEffect(element, 'fadeOut');
        }, 3000);
    }

    handleFreeShippingBar() {
        if (ProgressBarType === 'pack_progress') {
            this.managePackProgressBar();
        } else {
            this.manageTotalItemsProgress();
        }
    }

    managePackProgressBar() {
        let atLeastOnePack = false;
        let discountApplied = false;
        let otItemsCount = 0;
        let currentCountry = Shopify?.country || 'US';
        let isOtherCountry = currentCountry !== 'US';
        let cartObject = window.globalVariables.cart;
        let settings = window.globalVariables.settings;

        for (let item of cartObject?.items) {
            if (item?.title?.toLowerCase().includes('pack')) {
                atLeastOnePack = true;
            }
            if (item) {
                if (item.product_type !== 'Gift Cards') {
                    if (item.title.toLowerCase().includes('4') && item.title.toLowerCase().includes('pack') && item.handle.toLowerCase().includes('4-pack'))
                        otItemsCount = otItemsCount + item.quantity * 4;
                    else if (item.title.toLowerCase().includes('6') && item.title.toLowerCase().includes('pack') && item.handle.toLowerCase().includes('6-pack'))
                        otItemsCount = otItemsCount + item.quantity * 6;
                    else if (item.title.toLowerCase().includes('10') && item.title.toLowerCase().includes('pack') && item.handle.toLowerCase().includes('10-pack'))
                        otItemsCount = otItemsCount + item.quantity * 10;
                    else
                        otItemsCount = otItemsCount + item.quantity;
                }
            }
        }

        let customHeaderPB = document.querySelector('cart-form [data-custom-header] .cm-progress .progress-bar');

        window._overRideWithPackOffer = false;
        document.querySelector('cart-form [data-no-offer-text]')?.classList.remove('d-none');
        document.querySelector('cart-form [data-received-offer-text]')?.classList.add('d-none');

        if (cartObject && cartObject.total_price && cartObject.total_price > 0) {
            customHeaderPB.style.width = `${55}%`;
            let noOfferElement = document.querySelector('cart-form [data-no-offer-text]')
            if (noOfferElement) {
                noOfferElement.innerHTML = `<span class="mb-0" data-no-offer-text>You’re <span class="text-black fw-bold" data-remaining-amount>1 pack</span> away from 10% off your entire order</span>`;
            }
        } else {
            if (customHeaderPB) {
                customHeaderPB.style.width = `${0}%`;
            }
            document.querySelector('cart-form [data-item-first]')?.classList.remove('achieved');
            let noOfferElement = document.querySelector('cart-form [data-no-offer-text]')
            if (noOfferElement) {
                noOfferElement.classList.remove('d-none');
                noOfferElement.innerHTML = `<span class="mb-0" data-no-offer-text>You’re <span class="text-black fw-bold" data-remaining-amount>1 pack</span> away from 10% off your entire order</span>`;
            }
            document.querySelector('cart-form [data-received-offer-text]')?.classList.add('d-none');
        }

        let countExcludedTags = settings.cart_item_exclude_tag;
        let excludeQuantity = 0;
        if (countExcludedTags) {
            countExcludedTags = countExcludedTags.split(',');
            document.querySelectorAll('.cart-drawer [data-cart-item]').forEach(ele => {
                let productTags = ele.querySelector('[data-pd-tags]')?.getAttribute('data-pd-tags');
                if (productTags) {
                    productTags = JSON.parse(productTags);
                    let isExcludedProduct = productTags.some(value => countExcludedTags.includes(value));
                    if (isExcludedProduct) {
                        excludeQuantity += parseInt(ele.querySelector('[data-qty-input]')?.getAttribute('value') || 0);
                    }
                }
            })
        }
    }

    manageTotalItemsProgress() {
        let otItemsCount = 0;
        let realItemCount = 0;
        let otItemsNeeded = window.globalVariables?.settings.required_items || 7;
        let otItemsPercent = 0;
        let otItemsPercentForB2B = 0;
        let otDiscount = "25";
        let cartObject = window.globalVariables.cart;

        this.querySelectorAll('[data-cart-item]').forEach(itemEle => {
            const packCount = parseInt(itemEle.getAttribute('data-pack-count') || '1');
            const itemKey = itemEle.getAttribute('data-item-key');
            const item = cartObject?.items?.find(i => i.key === itemKey);

            if (item && item.original_line_price > 0 && item.properties?._source !== '_free_gift') {
                if (item.product_type !== 'Gift Cards' && item.handle !== 'mystery-gift') {
                    realItemCount += item.quantity * packCount;
                }
            }
        });

        otItemsCount = realItemCount;

        if (otItemsCount >= 7) {
            otItemsNeeded = 7;
            otDiscount = 25;
        }
        else if (otItemsCount >= 5) {
            otItemsNeeded = 7;
            otDiscount = 25;
        } else if (otItemsCount >= 3) {
            otItemsNeeded = 5;
            otDiscount = 20;
        } else {
            otItemsNeeded = 3;
            otDiscount = 15;
        }

        const normalTagContainers = this.querySelectorAll('.norml_offer_content .bfcm_offer_badge_custom.normal');
        const normalTagSingleContainers = this.querySelectorAll('.norml_offer_content .bfcm_offer_badge_custom.normal.single');
        const sleepTagContainers = this.querySelectorAll('.norml_offer_content.tag-sleep2025_release .bfcm_offer_badge_custom.normal.single');

        if (otItemsCount >= 7) {
            normalTagSingleContainers.forEach(c => { const s = c.querySelector('span'); if (s) s.innerHTML = '25% OFF'; });
            normalTagContainers.forEach(c => { const s = c.querySelector('span'); if (s) s.innerHTML = '25% OFF'; });
        } else if (otItemsCount >= 5) {
            normalTagSingleContainers.forEach(c => { const s = c.querySelector('span'); if (s) s.innerHTML = '20% OFF'; });
            normalTagContainers.forEach(c => { const s = c.querySelector('span'); if (s) s.innerHTML = '20% OFF'; });
        } else if (otItemsCount >= 3) {
            normalTagSingleContainers.forEach(c => { const s = c.querySelector('span'); if (s) s.innerHTML = '15% OFF'; });
            normalTagContainers.forEach(c => { const s = c.querySelector('span'); if (s) s.innerHTML = '15% OFF'; });
        } else {
            normalTagSingleContainers.forEach(c => { const s = c.querySelector('span'); if (s) s.innerHTML = '15% OFF 3+'; });
        }

        sleepTagContainers.forEach(c => { const s = c.querySelector('span'); if (s) s.innerHTML = '10% OFF 2+'; });

        let cartItemCounter = document.querySelector('.cart-item-counter');
        if (cartItemCounter) {
            if (realItemCount === 0) {
                cartItemCounter.classList.add('d-none');
            } else {
                cartItemCounter.classList.remove('d-none');
                cartItemCounter.innerHTML = `Your ${realItemCount === 1 ? 'item' : 'items'} (${realItemCount})`;
            }
        }

        let otItemsDiff = otItemsNeeded - otItemsCount;
        let message = "";

        if (otItemsDiff > 0) {
            if (otItemsCount >= 5) {
                message = `<span>Congrats 20% OFF applied! — </span><span class="progressbar-second-message">Add ${otItemsDiff} ${otItemsDiff <= 1 ? 'item' : 'items'} for ${otDiscount}% OFF</span>`;
            } else if (otItemsCount >= 3) {
                message = `<span>Congrats 15% OFF applied! — </span><span class="progressbar-second-message">Add ${otItemsDiff} ${otItemsDiff <= 1 ? 'item' : 'items'} for ${otDiscount}% OFF</span>`;
            } else {
                message = `<span>Add ${otItemsDiff} ${otItemsDiff <= 1 ? 'item' : 'items'} for ${otDiscount}% OFF</span>`;
            }
        } else {
            message = `<span>Congrats ${otDiscount}% OFF applied!</span>`;
        }

        if (otItemsCount < 1) {
            otItemsPercent = 0;
        } else {
            otItemsPercent = Math.min(Math.round((otItemsCount) / 7 * 100), 100);
        }

        const TARGET_AMOUNT = 30000;
        const totalPrice = cartObject?.total_price || 0;
        const remainingAmount = Math.max(TARGET_AMOUNT - totalPrice, 0);
        const remainingAmountFormatted = `$${(remainingAmount / 100).toLocaleString('en-US', {
            minimumFractionDigits: 0,
            maximumFractionDigits: 2
        })}`;
        if (totalPrice <= 0) {
            otItemsPercentForB2B = 0;
        } else {
            otItemsPercentForB2B = Math.min(
                Math.round((totalPrice / TARGET_AMOUNT) * 100),
                100
            );
        }

        let customHeaderP = document.querySelector('cart-form [data-no-offer-text]');
        let customHeaderAB = document.querySelector('cart-form [data-offer-textAB]');
        if (customHeaderP) customHeaderP.innerHTML = message;
        if (customHeaderAB) customHeaderAB.innerHTML = message.replace('font-openSans f-14', '');

        let customHeaderPB = document.querySelector('cart-form [data-custom-header] .cm-progress .progress-bar');
        let customHeaderPBForB2B = document.querySelector('cart-form [data-custom-header] .cm-progress.cm-b2b-progress .progress-bar');
         let b2bMessageEl = document.querySelector('cart-form [data-custom-header] .b2b-message');

        if (b2bMessageEl) {
            if (remainingAmount > 0) {
            console.log(remainingAmount,"remainingAmount")
                b2bMessageEl.innerHTML = `<span>Add <span class="b2b-price">${remainingAmountFormatted}</span> in products to unlock checkout</span>`;
            } else {
                b2bMessageEl.innerHTML = `<span>Congrats! You’ve unlocked Wholesale discount!</span>`;
            }
        }

        if (customHeaderPB) customHeaderPB.style.width = `${otItemsPercent}%`;
        if (customHeaderPBForB2B) customHeaderPBForB2B.style.width = `${otItemsPercentForB2B}%`;
    }

    async manageGiftItem(realItemCount) {
        const GIFT_ITEM_VARIANT_ID = 41595795931198;
        const cartObject = window.globalVariables.cart;
        if (this.addingGift || this.removingGift) return;

        const giftItem = cartObject.items.find(item => {
            const isGiftVariant = Number(item.variant_id) === Number(GIFT_ITEM_VARIANT_ID) || Number(item.id) === Number(GIFT_ITEM_VARIANT_ID);
            const hasGiftProperty = item.properties && item.properties._source === '_free_gift';
            return isGiftVariant && hasGiftProperty;
        });

        if (realItemCount >= 5) {
            if (!giftItem && !this.addingGift) {
                this.addingGift = true;
                const formData = {
                    'items': [{
                        'id': GIFT_ITEM_VARIANT_ID,
                        'quantity': 1,
                        'properties': { '_source': '_free_gift' }
                    }],
                    'sections': this.sectionID
                };
                fetch(`${routes.cart_add_url}.js`, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify(formData)
                })
                    .then(response => response.json())
                    .then(async (data) => {
                        await this.getCartData();
                    })
                    .catch(err => {
                        console.error('Error adding free gift:', err);
                    })
                    .finally(() => {
                        setTimeout(() => {
                            this.addingGift = false;
                        }, 500);
                    });
            }
        } else {
            if (giftItem && !this.removingGift) {
                this.removingGift = true;
                const itemIndex = cartObject.items.indexOf(giftItem) + 1;
                this.updateItemQty(itemIndex, 0);
                setTimeout(() => { this.removingGift = false; }, 3000);
            }

            let giftMessageContainer = document.querySelector('cart-form .gift-section .gift-item-message');
            if (giftMessageContainer) {
                let remainingCountForGift = 5 - realItemCount;
                giftMessageContainer.innerHTML = remainingCountForGift > 0 ? `Add ${remainingCountForGift} ${remainingCountForGift > 1 ? 'items' : 'item'} to unlock the free gift` : '';
            }
        }

        let giftContainer = document.querySelector('cart-form .gift-section');
        if (document.querySelector('cart-form .free_gift_item_content')) {
            giftContainer?.classList?.remove('locked');
        } else {
            giftContainer?.classList?.add('locked');
        }
    }


    manageCartItemOfferLabel(itemCount) {
        let remainingCount = 4 - itemCount;
        let otDiscount = "30";
        let cartObject = window.globalVariables.cart;

        document.querySelectorAll('[data-remaining-offer]').forEach(ele => {
            let productTags = ele.closest('[data-pd-tags]')?.getAttribute('data-pd-tags');
            let itemContainer = ele.closest('[data-cart-item]');
            let isClearanceProduct = false;
            let isXSDiscountProduct = false;
            let isXSProduct = itemContainer.querySelector('[data-cart-size-value]')?.getAttribute('data-cart-size-value') === 'XS'
            if (productTags) {
                productTags = JSON.parse(productTags);
                isClearanceProduct = productTags.includes('CLEARANCE35');
                isXSDiscountProduct = productTags.includes('XS_DISCOUNT') && isXSProduct;
            }
            if (remainingCount > 0 && !isClearanceProduct && !isXSDiscountProduct) {
                ele.classList.remove('d-none');
                ele.innerHTML = `Add ${remainingCount} more to save ${otDiscount}%`;
            } else {
                ele.classList.add('d-none');
            }
        });

        document.querySelectorAll('[data-applied-discount]').forEach(ele => {
            let productTags = ele.closest('[data-pd-tags]')?.getAttribute('data-pd-tags');
            let itemContainer = ele.closest('[data-cart-item]');
            let isClearanceProduct = false;
            let isXSDiscountProduct = false;
            let isXSProduct = itemContainer.querySelector('[data-cart-size-value]')?.getAttribute('data-cart-size-value') === 'XS'
            if (productTags) {
                productTags = JSON.parse(productTags);
                isClearanceProduct = productTags.includes('CLEARANCE35');
                isXSDiscountProduct = productTags.includes('XS_DISCOUNT') && isXSProduct;
            }
            if (remainingCount > 0 && !isClearanceProduct && !isXSDiscountProduct) {
                ele.classList.add('d-none');
            } else {
                ele.classList.remove('d-none');
                ele.innerHTML = "Hooray, you’re saving!";
            }
        });

        let cartCountElements = document.querySelectorAll('#cart-icon-desktop .cart-count_bf');
        if (cartObject) {
            cartCountElements.forEach((cartCountElement) => {
                cartCountElement.innerHTML = cartObject.item_count;
            });
        }
    }

    calculateDiscount() {
        let cartData = window.globalVariables.cart;
        if (!cartData) return;

        let cartDiscount = 0;

        // Use the pre-calculated discount values from liquid rendered items
        document.querySelectorAll('[data-cart-item][data-item-discount]').forEach(ele => {
            let discountValue = parseFloat(ele.getAttribute('data-item-discount') || 0);
            cartDiscount += discountValue;
        });

        if (drawerSelectors.cartTotalDiscount) {
            drawerSelectors.cartTotalDiscount.innerHTML = Shopify.formatMoney(cartDiscount * 100, window.globalVariables.money_format);
            if (cartDiscount > 0) {
                this.querySelector('.total_discount_container')?.classList?.remove('d-none');
            } else {
                this.querySelector('.total_discount_container')?.classList?.add('d-none');
            }
        }

        // Subtotal should already be correct from the Shopify response, but if we need a "compare at" subtotal:
        let actualSubtotalCents = cartData.total_price;
        document.querySelectorAll('[data-cart-item][data-item-discount]').forEach(ele => {
            actualSubtotalCents += parseFloat(ele.getAttribute('data-item-discount') || 0) * 100;
        });
    }

    manageSpecialDiscount() {
        const requiredItems = 3;
        let otItemsCount = 0;
        let cartObject = window.globalVariables.cart || [];
        const cartLineItemElement = document.querySelector('cart-form .cart-form-container');
        if (cartLineItemElement) {
            let eligibleOffers = {};

            // --------------- Remove discount text from all items ---------------
            const cartLineItems = cartLineItemElement?.querySelectorAll('.cart-product-wrapper .cart-items');
            if (cartLineItems) {
                cartLineItems.forEach((cartLineItem) => {
                    cartLineItem.querySelector('[data-applied-discount]')?.classList.add('d-none');
                    cartLineItem.querySelector('[data-remaining-offer]')?.classList.add('d-none');
                });
            }

            for (let item of cartObject.items) {
                let cartItemContainer = cartLineItemElement.querySelector(`[data-variant-id="${item.id}"]`);
                let productTags = cartItemContainer.querySelector('[data-pd-tags]')?.getAttribute('data-pd-tags');
                let productDetails = { tags: [] }
                if (productTags) {
                    productTags = JSON.parse(productTags);
                    productDetails = { tags: productTags }
                }

                const {
                    offerCartSuccessMsg,
                    offerTags,
                    offerCartTagLine,
                    offerShowCheckIcon
                } = this.getOfferSettings(productDetails);

                if (offerCartTagLine && offerCartSuccessMsg) {
                    offerTags.forEach((offerTag) => {
                        if (!eligibleOffers[offerTag]) {
                            eligibleOffers[offerTag] = {
                                variant_ids: [],
                                variant_count: 0,
                                variant_success_msg: offerCartSuccessMsg,
                                variant_tag_line: offerCartTagLine,
                                variant_show_check_icon: offerShowCheckIcon
                            }
                        }

                        eligibleOffers[offerTag].variant_count += item.quantity

                        if (!eligibleOffers[offerTag].variant_ids.includes(item.id)) {
                            eligibleOffers[offerTag].variant_ids.push(item.id)
                        }
                    })
                }

                if (item && item.product_type !== 'Gift Cards' && item.handle !== 'mystery-gift') {
                    if (item.title.toLowerCase().includes('4') && item.title.toLowerCase().includes('pack') && item.handle.toLowerCase().includes('4-pack'))
                        otItemsCount = otItemsCount + item.quantity * 4;
                    else if (item.title.toLowerCase().includes('6') && item.title.toLowerCase().includes('pack') && item.handle.toLowerCase().includes('6-pack'))
                        otItemsCount = otItemsCount + item.quantity * 6;
                    else if (item.title.toLowerCase().includes('10') && item.title.toLowerCase().includes('pack') && item.handle.toLowerCase().includes('10-pack'))
                        otItemsCount = otItemsCount + item.quantity * 10;
                    else
                        otItemsCount = otItemsCount + item.quantity;
                }
            }

            for (const [eligibleOfferKey, eligibleOffer] of Object.entries(eligibleOffers)) {
                const variantIds = eligibleOffer.variant_ids;
                let originalRequiredItems = requiredItems;
                let variantCountForOffer = eligibleOffer.variant_count;
                if (eligibleOffer.variant_tag_line.includes('_christmas_offer')) {
                    originalRequiredItems = 4;
                    variantCountForOffer = otItemsCount;
                }
                if (variantCountForOffer >= originalRequiredItems) {
                    variantIds.forEach((variantId) => {
                        let element = cartLineItemElement.querySelector(`[data-variant-id="${variantId}"] .discount-applied-message`)?.closest(`[data-variant-id="${variantId}"`);
                        if (element) {
                            element.querySelector('[data-applied-discount]')?.classList.remove('d-none');
                            element.querySelector('[data-applied-discount] span').innerHTML = eligibleOffer.variant_success_msg;
                            if (eligibleOffer.variant_show_check_icon) {
                                element.querySelector('[data-applied-discount] .tagline-badge')?.classList?.remove('d-none');
                                element.querySelector('[data-applied-discount] .tagline-badge')?.classList?.add('d-inline-flex');
                            }
                            element.querySelector('[data-remaining-offer]')?.classList?.add('d-none');
                        }
                    })
                } else {
                    variantIds.forEach((variantId) => {
                        let element = cartLineItemElement.querySelector(`[data-variant-id="${variantId}"] .discount-applied-message`)?.closest(`[data-variant-id="${variantId}"`);
                        if (element) {
                            element.querySelector('[data-applied-discount]')?.classList.add('d-none');
                            let remainingCount = originalRequiredItems - variantCountForOffer;
                            let remainingOfferEle = element.querySelector('[data-remaining-offer]');
                            if (remainingOfferEle) {
                                remainingOfferEle.classList.remove('d-none');
                                remainingOfferEle.innerHTML = eligibleOffer.variant_tag_line.replace('{x}', remainingCount.toString()).replace('_christmas_offer', '');
                            }
                        }
                    })
                }

                variantIds.forEach((variantId) => {
                    if (window._overRideWithPackOffer) {
                        let element = cartLineItemElement.querySelector(`[data-variant-id="${variantId}"] .discount-applied-message`)?.closest(`[data-variant-id="${variantId}"`);
                        element?.querySelector('[data-applied-discount]')?.classList.remove('d-none');
                        element?.querySelector('[data-remaining-offer]')?.classList.add('d-none');
                    }
                })
            }

            cartLineItems.forEach((cartLineItem) => {
                if (cartLineItem.classList.contains('tag-deal40')) {
                    if (cartLineItem.querySelector('[data-applied-discount]')) {
                        cartLineItem.querySelector('[data-applied-discount]')?.classList.remove('d-none');
                        cartLineItem.querySelector('[data-applied-discount] span').innerHTML = 'Hooray, you’re saving!';
                    }
                    cartLineItem.querySelector('[data-remaining-offer]')?.classList.add('d-none');
                }
            });
        }
    }

    getOffers() {
        window.offersJson = {}
        window.offersJson.enabled_offers = [];
        window.offersJson.default_offer = {}

        let settings = window.globalVariables.settings;

        for (let i of [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19].reverse()) {
            let enabled = settings[`enable_offer_${i}`];
            if (enabled) {
                window.offersJson.enabled_offers.push({
                    enabled: settings[`enable_offer_${i}`],
                    offer_type: settings[`offer_${i}_type`],
                    discount: settings[`offer_${i}_discount_percentage`],
                    tags: settings[`offer_${i}_tag`]?.split(','),
                    exclude_tags: settings[`offer_${i}_exclude_tags`]?.split(','),
                    priceFormat: settings[`offer_${i}_price_format`],
                    label: settings[`offer_${i}_tag_name`],
                    deal_label: settings[`offer_${i}_deal_tag_name`],
                    label_color: settings[`offer_${i}_tag_color`],
                    label_bg_color: settings[`offer_${i}_tag_bg_color`],
                    label_border_color: settings[`offer_${i}_label_stroke_color`],
                    label_border_radius: settings[`offer_${i}_label_radius`],
                    tag_line: settings[`offer_${i}_tag_line`],
                    show_check_icon: settings[`offer_${i}_show_check_icon`],
                    cart_label: settings[`offer_${i}_cart_label`],
                    cart_tag_line: settings[`offer_${i}_cart_tag_line`],
                    cart_success_msg: settings[`offer_${i}_cart_success_msg`],
                });
            }
        }
    }

    getOfferSettings(productDetails, compareAtPriceValue, priceValue) {
        let productTags = productDetails.tags || [];
        let offerApplied = false;
        let customOffers = window.offersJson.enabled_offers

        let offerTags = [];
        let offerType = null;
        let offerExcludeTags = [];
        let offerDiscount = null;
        let offerDiscountAmount = null;
        let offerPrice = null;
        let offerLabel = null;
        let offerDealLabel = null;
        let displayedPrice = '{price} {subscription_price}';
        let offerLabelColor = null;
        let offerLabelBackground = null;
        let offerTagLine = null;
        let offerTagLineColor = '#CE0000';
        let offerStrokeColor = null;
        let offerBorderRadius = null;
        let offerCartLabel = null;
        let offerCartTagLine = null;
        let offerCartSuccessMsg = null;
        let offerShowCheckIcon = false;

        if (customOffers.length) {
            customOffers.forEach((customOffer) => {
                if (
                    !offerApplied &&
                    customOffer.tags?.length && customOffer.tags.filter(customOfferTag => productTags.includes(customOfferTag))?.length
                ) {
                    offerApplied = true;
                    offerType = customOffer.offer_type;
                    offerDiscount = customOffer.discount;
                    offerDiscountAmount = (priceValue * offerDiscount) / 100;
                    offerPrice = priceValue - offerDiscountAmount;
                    displayedPrice = customOffer.priceFormat;
                    offerTags = customOffer.tags;
                    offerExcludeTags = customOffer.exclude_tags;
                    offerLabel = customOffer.label;
                    offerDealLabel = customOffer.deal_label;
                    offerLabelColor = customOffer.label_color;
                    offerLabelBackground = customOffer.label_bg_color;
                    offerTagLine = customOffer.tag_line;
                    offerTagLineColor = customOffer.tag_line_color;
                    offerShowCheckIcon = customOffer.show_check_icon;
                    offerStrokeColor = customOffer.label_border_color;
                    offerBorderRadius = customOffer.label_border_radius;
                    offerCartLabel = customOffer.cart_label;
                    offerCartTagLine = customOffer.cart_tag_line;
                    offerCartSuccessMsg = customOffer.cart_success_msg;
                }
            })
        }

        return {
            offerApplied: offerApplied,
            offerType: offerType,
            offerTags: offerTags,
            offerExcludeTags: offerExcludeTags,
            offerDiscount: offerDiscount,
            offerDiscountAmount: offerDiscountAmount,
            offerPrice: offerPrice,
            displayedPrice: displayedPrice,
            offerLabel: offerLabel,
            offerDealLabel: offerDealLabel,
            offerLabelColor: offerLabelColor,
            offerLabelBackground: offerLabelBackground,
            offerTagLine: offerTagLine,
            offerTagLineColor: offerTagLineColor,
            offerStrokeColor: offerStrokeColor,
            offerBorderRadius: offerBorderRadius,
            offerCartLabel: offerCartLabel,
            offerCartTagLine: offerCartTagLine,
            offerCartSuccessMsg: offerCartSuccessMsg,
            offerShowCheckIcon: offerShowCheckIcon,
        }
    }

    startCountdown(time, resetTime = 5) {
        let countdownTime = time;

        setInterval(function () {

            // Update the display
            const minutes = Math.floor(countdownTime / 60);
            const seconds = countdownTime % 60;
            const displayText = `${minutes < 10 ? '0' : ''}${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
            let cartElement = document.getElementById('custom-cart-countdown');
            if (!cartElement) {
                return;
            }
            cartElement.innerHTML = displayText;

            // Store the remaining time in localStorage
            localStorage.setItem('countdownTime', countdownTime);

            if (countdownTime <= 0) {
                countdownTime = resetTime * 60; // Reset to 10 minutes
                localStorage.setItem('countdownTime', countdownTime);
            } else {
                countdownTime--;
            }
        }, 1000);
    }

    updatePromotionGroupTaglines() {
        const containers = this.querySelectorAll('.promotion-group-container');
        const themeSettings = window.globalVariables?.settings;
        if (!themeSettings) return;

        const cartObject = window.globalVariables.cart;

        // Calculate total cart items weighted by pack size (matching progress bar logic)
        let totalWeightedItems = 0;
        this.querySelectorAll('[data-cart-item]').forEach(itemEle => {
            const packCount = parseInt(itemEle.getAttribute('data-pack-count') || '1');
            const itemKey = itemEle.getAttribute('data-item-key');
            const item = cartObject?.items?.find(i => i.key === itemKey);

            if (item && item.original_line_price > 0 && item.properties?._source !== '_free_gift') {
                if (item.product_type !== 'Gift Cards' && item.handle !== 'mystery-gift') {
                    totalWeightedItems += item.quantity * packCount;
                }
            }
        });

        containers.forEach((container) => {
            const groupTagline = container.querySelector('.promo-tagline');
            if (!groupTagline) return;

            const dynamicText = groupTagline.querySelector('.dynamic-text');
            const groupNumber = container.getAttribute('data-promo-group');

            // Calculate group-specific weighted items
            let groupWeightedItems = 0;
            container.querySelectorAll('[data-cart-item]').forEach(itemEle => {
                const packCount = parseInt(itemEle.getAttribute('data-pack-count') || '1');
                const itemKey = itemEle.getAttribute('data-item-key');
                const item = cartObject?.items?.find(i => i.key === itemKey);

                if (item && item.original_line_price > 0 && item.properties?._source !== '_free_gift') {
                    if (item.product_type !== 'Gift Cards' && item.handle !== 'mystery-gift') {
                        groupWeightedItems += item.quantity * packCount;
                    }
                }
            });

            const currentCount = (groupNumber === '1') ? totalWeightedItems : groupWeightedItems;

            if (groupNumber === '4') {
                groupTagline.classList.remove('d-none');
                dynamicText.innerHTML = `Congrats! Add more for 10% off`;
                return;
            }

            const thresholds = [3, 5, 7];
            const matchedThreshold = thresholds.find(threshold => currentCount < threshold);

            if (!matchedThreshold) {
                groupTagline.classList.remove('d-none');
                if (groupNumber === '1') {
                    dynamicText.innerHTML = `Congrats! Add more for 25% off`;
                } else {
                    dynamicText.innerHTML = `Congrats! Add more at this price`;
                }
                return;
            }

            const remaining = matchedThreshold - currentCount;
            const priceKey = `promotion_${groupNumber}_price_${matchedThreshold}pack`;
            const promoType = themeSettings[`promotion_${groupNumber}_type`];
            const price = themeSettings?.[priceKey];

            if (!price) {
                groupTagline.classList.add('d-none');
                return;
            }

            groupTagline.classList.remove('d-none');
            const congratsMsg = matchedThreshold > 3 ? 'Congrats! ' : '';
            if (promoType === 'percentage') {
                dynamicText.innerHTML = `${congratsMsg}Add <span data-remaining-item="">${remaining}</span> more to get <span class="fw-semibold">${matchedThreshold} at ${price}% off</span>`;
            } else {
                dynamicText.innerHTML = `${congratsMsg}Add <span data-remaining-item="">${remaining}</span> more to get <span class="fw-semibold">${matchedThreshold} for $${price}</span>`;
            }
        });
    }
}
customElements.define("cart-form", AjaxCart);